export default __webpack_public_path__ + "static/media/wave.d7de9de6.svg";